module.exports = __webpack_public_path__ + "static/f36b7d69e529bbb60e47bc38a9df2056edc829e5e21a4555edb67f0480dbcb20-d1e4f56073ef54ecccec02f31099d4e8.png";